import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const PDFViewer = ({ pdfUrl, onClose }) => {

  return (
    <div className="fixed inset-0 bg-black z-50">
      <div className="w-full h-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 bg-gray-800/80 hover:bg-gray-700/80 text-white p-2 rounded-full transition-all"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>
        <iframe
          src={pdfUrl}
          className="w-full h-full"
          title="PDF Viewer"
        />
      </div>
    </div>
  );
};

export default PDFViewer;
